// Import model
import { StartProposalShareInstallationPlanRequest } from '../models/StartProposalShareInstallationPlanRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProposalShareInstallationPlanRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProposalShareInstallationPlanRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProposalShareInstallationPlanRequest instance
   */
  static deserialize(json: string): StartProposalShareInstallationPlanRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProposalShareInstallationPlanRequest instance
   */
  static fromObject(obj: any): StartProposalShareInstallationPlanRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProposalShareInstallationPlanRequest');
    }


    const instance: StartProposalShareInstallationPlanRequest = {
      fromName: obj['FromName'] as string | undefined,
      fromEmail: obj['FromEmail'] as string | undefined,
      ccEmail: obj['CCEmail'] as string | undefined,
      toName: obj['ToName'] as string | undefined,
      toEmail: obj['ToEmail'] as string | undefined,
      subject: obj['Subject'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProposalShareInstallationPlanRequest instances
   */
  static deserializeArray(json: string): StartProposalShareInstallationPlanRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProposalShareInstallationPlanRequest instance to a JSON string
   */
  static serialize(instance: StartProposalShareInstallationPlanRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProposalShareInstallationPlanRequest instance to a plain object
   */
  static toObject(instance: StartProposalShareInstallationPlanRequest): any {
    return {
      'FromName': instance.fromName,
      'FromEmail': instance.fromEmail,
      'CCEmail': instance.ccEmail,
      'ToName': instance.toName,
      'ToEmail': instance.toEmail,
      'Subject': instance.subject,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartProposalShareInstallationPlanRequest instances to a JSON string
   */
  static serializeArray(instances: StartProposalShareInstallationPlanRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
